import React, { useState } from "react";
import CloseIcon from "@styles/all-images/icons/closeblack.svg";
import ArrowDownIcon from "@styles/all-images/icons/chevron-down.svg";

interface AddStaffFormProps {
  onClose: () => void;
  onSubmit: () => void;
  isStaffModalOpen: boolean;
}

const AddStaffForm = ({
  onClose,
  onSubmit,
  isStaffModalOpen,
}: AddStaffFormProps) => {
  const [selectedRoles, setSelectedRoles] = useState<string[]>([]);
  const [isRolesOpen, setIsRolesOpen] = useState(false);

  const availableRoles = ["Admin", "Manager", "Editor", "Viewer", "User"];

  const handleRoleSelect = (role: string) => {
    if (!selectedRoles.includes(role)) {
      setSelectedRoles([...selectedRoles, role]);
    }
    setIsRolesOpen(false);
  };

  const handleRemoveRole = (roleToRemove: string, e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setSelectedRoles(selectedRoles.filter((role) => role !== roleToRemove));
  };

  const displayRoles = selectedRoles.slice(0, 2);
  const remainingCount = selectedRoles.length - 2;

  return (
    <div
      className={`tw-fixed tw-bg-black/25 tw-top-0 tw-min-h-screen tw-flex tw-items-center tw-justify-center tw-z-50 tw-transition-all tw-ease-in-out tw-duration-1000 ${
        isStaffModalOpen ? "tw-right-0" : "tw-right-[-265px]"
      }`}
    >
      <div className="tw-bg-white tw-shadow-lg tw-mx-auto tw-h-screen ">
        <div className="tw-flex tw-justify-between tw-items-center tw-px-4 tw-py-2 tw-border-b">
          <h2 className="tw-text-base tw-font-semibold">Edit Profile</h2>
          <button onClick={onClose}>
            <img src={CloseIcon} alt="Close" className="tw-w-auto tw-h-auto" />
          </button>
        </div>
        <div className="tw-flex tw-flex-col tw-justify-between tw-h-[95%] tw-px-4 tw-py-4 ">
          <form className="tw-space-y-6">
            <div className="form-group">
              <label
                htmlFor="profileName"
                className="tw-block tw-text-sm tw-text-[#414651] tw-font-medium tw-mb-2"
              >
                Profile Name <span className="tw-text-[#B54708]">*</span>
              </label>
              <input
                id="profileName"
                type="text"
                placeholder="Enter profile name"
                className="tw-w-full tw-h-11 tw-px-3 tw-border tw-border-[#D5D7DA] tw-text-[#717680] tw-font-normal tw-rounded-md tw-focus:outline-none tw-focus:ring-2 tw-focus:ring-blue-500"
              />
            </div>

            <div className="form-group">
              <label
                htmlFor="roles"
                className="tw-block tw-text-sm tw-text-[#414651] tw-font-medi tw-mb-2"
              >
                Roles
              </label>
              <div className="tw-relative">
                <button
                  type="button"
                  role="combobox"
                  aria-expanded={isRolesOpen}
                  aria-haspopup="listbox"
                  onClick={() => setIsRolesOpen(!isRolesOpen)}
                  className="tw-w-full tw-min-h-[44px] tw-max-h-[44px] tw-px-2 tw-py-1 tw-border tw-border-[#D5D7DA] tw-rounded-md tw-cursor-pointer tw-flex tw-items-center tw-flex-wrap tw-gap-2"
                >
                  {displayRoles.map((role, index) => (
                    <span
                      key={index}
                      className="tw-px-2 tw-bg-[#F8FAFC] tw-py-1 tw-border tw-border-[#E9EAEB] tw-rounded-lg tw-text-sm tw-text-[#232323] tw-flex tw-items-center tw-gap-1"
                    >
                      {role}
                      <button
                        onClick={(e) => handleRemoveRole(role, e)}
                        type="button"
                        className="tw-text-[#717680] hover:tw-text-[#232323]"
                      >
                        <img
                          src={CloseIcon}
                          alt="Close"
                          className="tw-w-[10px] tw-h-[10px] tw-ml-2"
                        />
                      </button>
                    </span>
                  ))}
                  {remainingCount > 0 && (
                    <span className="tw-bg-[#146C94] tw-text-white tw-text-sm tw-font-normal tw-px-2 tw-py-1 tw-rounded-full">
                      +{remainingCount}
                    </span>
                  )}
                  <img
                    src={ArrowDownIcon}
                    alt="Arrow Down"
                    className={`tw-w-4 tw-h-4 tw-ml-auto tw-transform ${isRolesOpen ? "tw-rotate-180" : ""}`}
                  />
                </button>

                {isRolesOpen && (
                  <div
                    role="listbox"
                    className="tw-absolute tw-left-0 tw-right-0 tw-mt-1 tw-bg-white tw-border tw-border-[#E9EAEB] tw-rounded-md tw-shadow-lg tw-z-10"
                  >
                    {availableRoles.map((role, index) => (
                      <button
                        key={index}
                        type="button"
                        role="option"
                        aria-selected={selectedRoles.includes(role)}
                        onClick={() => handleRoleSelect(role)}
                        className="tw-w-full tw-text-left tw-px-4 tw-py-2 hover:tw-bg-[#F8FAFC] tw-cursor-pointer"
                      >
                        {role}
                      </button>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </form>
          <div>
            <button
              onClick={onSubmit}
              type="submit"
              className="tw-w-full primary-custom-button"
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddStaffForm;
